import React, { useEffect, useReducer } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PageTitleContainer from '../common/PageTitleContainer';
import TablePagination from '@mui/material/TablePagination';
import { findAllUsers, deleteUser, findAllRoles, findAllTeams } from '../../redux';
import CustomDialog from '../ui/CustomDialog';
import DeleteConfirmDialog from '../ui/DeleteConfirmDialog';
import ViewDetails from './ViewDetails';
import EditForm from './EditForm';
import { GetTcolumns, GetTsearch, GetTvalues } from './TableData';
import SortTable from '../common/SortTable';
import ToggleTableTrash from '../common/ToggleTableTrash';

const initialStateFilter = {
  deleted: false,
  page: 0,
  pagesize: 10,
  sort: 'user_profile.name',
  direction: 'ASC',
  name: '',
  email: '',
  teamId: '',
  roleId: '',
  active: '',
}

const initialStateOther = {
  pageLoaded: false,
  modalDiaLogTitle: '',
  modalDiaLogId: false,
  openDelete: false,
  openView: false,
  openEdit: false,
}

const reducerFilter = (state, action) => {
  return {
  ...state,
  ...action
  }
}

const UserContainer = (props) => {

  const [state, updateState] = useReducer(reducerFilter, initialStateFilter);
  const [state2, updateState2] = useReducer(reducerFilter, initialStateOther);
  const ui = useSelector((state) => state.ui);
  const user = useSelector((state) => state.user);
  const role = useSelector((state) => state.role);
  const team = useSelector((state) => state.team);
  const session = useSelector((state) => state.session);
  const dispatch = useDispatch();

  const setOpen = (open, modalDiaLogId=false, modalDiaLogTitle='', modalName=null) => {
    updateState2({ modalDiaLogId: modalDiaLogId });
    updateState2({ modalDiaLogTitle: modalDiaLogTitle });

    if(modalName !== null) {
      if(modalName === 'VIEW') {
        updateState2({ openView: open });
      } else if(modalName === 'EDIT') {
        updateState2({ openEdit: open });
      } else if(modalName === 'DELETE') {
        updateState2({ openDelete: open });
      }
    } else {
      updateState2({ openView: false });
      updateState2({ openEdit: false });
      updateState2({ openDelete: false });
    }

  }
  const _deleteUser = (modalDiaLogId) => {
    dispatch(deleteUser(modalDiaLogId, state));
  }
  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    updateState({ [name]: value });

    /* on Selection */
    if(['sort','direction','deleted','active','teamId','roleId'].includes(name)) {
      updateState({ page: 0 });
      let newFilters = state;
      newFilters[name] = value;
      newFilters['page'] = 0;
      dispatch(findAllUsers(newFilters));
    }

  }
  const handleTableChangePage = (event, newPage) => {
    dispatch(findAllUsers({...state, page: newPage }));
    updateState({ page: newPage });
  }
  const handleTableChangeRowsPerPage = (event) => {
    dispatch(findAllUsers({...state, page: 0, pagesize: parseInt(event.target.value, 10) }));
    updateState({ page: 0, pagesize: parseInt(event.target.value, 10) });
  }
  const onSearchInputEnterKey = () => {
    dispatch(findAllUsers({...state, page: 0}));
    updateState({ page: 0 });
  }
  const resetTableSearchInput = () => {
    updateState2({ pageLoaded: false });
  }

  useEffect(() => {
    if(!state2.pageLoaded) {
      updateState(initialStateFilter);
      updateState2({ pageLoaded: true });
      dispatch(findAllRoles({ active:1, pagesize:1000, sort:'roleName', direction:'ASC'}));
      dispatch(findAllTeams({ active:1, pagesize:1000, sort:'teams.teamName', direction:'ASC'}));
      dispatch(findAllUsers(initialStateFilter));
    }
  }, [state2, dispatch]);

  /*** table columns ***/
  const t_data = user.data;
  const t_pagination = user.pagination;

  /*** table fields ***/
  const t_columns = <GetTcolumns
    openGlobalLoader={ui.openGlobalLoader}
    session={session} />

  /*** table search ***/
  const t_search = <GetTsearch
    onSearchInputEnterKey={onSearchInputEnterKey}
    handleInputChange={handleInputChange}
    resetTableSearchInput={resetTableSearchInput}
    role={role}
    team={team}
    session={session}
    name={state.name}
    email={state.email}
    teamId={state.teamId}
    roleId={state.roleId}
    active={state.active}
    />

  /*** table data ***/
  const t_values = <GetTvalues t_data={t_data}
    setOpen={setOpen}
    deleted={state.deleted}
    session={session}
    t_index={state.page * state.pagesize}
    />

  return (
    <main id="main" className="main">
      <PageTitleContainer pageTitle={props.pageTitle} ></PageTitleContainer>
      <section className="section">
        <div className="row">

          <CustomDialog maxWidth='sm' title={`View User ${state2.modalDiaLogTitle ? '- '+state2.modalDiaLogTitle : ''}`} open={state2.openView} setOpen={setOpen} >
            <ViewDetails
              modalDiaLogId={state2.modalDiaLogId}
              setOpen={setOpen}
            />
          </CustomDialog>

          <CustomDialog title={`Update User ${state2.modalDiaLogTitle ? '- '+state2.modalDiaLogTitle : ''}`} open={state2.openEdit} setOpen={setOpen} >
            <EditForm
              session={session}
              modalDiaLogId={state2.modalDiaLogId}
              setOpen={setOpen}
              role={role}
              team={team}
              filterInput={state}
            />
          </CustomDialog>

          <DeleteConfirmDialog
              title={`${ state.deleted ? 'Restore': 'Delete' } User ${state2.modalDiaLogTitle ? '- '+state2.modalDiaLogTitle : ''}`}
              modalDiaLogId={state2.modalDiaLogId}
              open={state2.openDelete}
              setOpen={setOpen}
              onConfirm={_deleteUser} >
            Are you sure you want to { state.deleted ? 'Restore': 'Delete' } user <strong className="p-2"> {state2.modalDiaLogTitle} </strong> ?
          </DeleteConfirmDialog>

        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">

                <div className="row mb-1">
                  <div className="col col-sm-9">
                    <div className="float-start">
                      <SortTable sortName={'user'}
                        sort={state.sort}
                        direction={state.direction}
                        handleInputChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="col">
                    <div className="float-end">
                      <ToggleTableTrash
                        deleted={state.deleted}
                        handleInputChange={handleInputChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>{ t_columns }</thead>
                    <tbody>
                      { t_search }
                      { t_values }
                    </tbody>
                  </table>
                </div>

                <TablePagination
                  component="div"
                  count={t_pagination.itemcount}
                  page={state.page}
                  onPageChange={handleTableChangePage}
                  rowsPerPage={state.pagesize}
                  onRowsPerPageChange={handleTableChangeRowsPerPage}
                  showFirstButton={true}
                  showLastButton={true} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )

}


export default UserContainer;
